<!-- 饼图的配置 -->
<template>
  <div>
    <el-collapse accordion>
      <el-collapse-item title="饼图设置">
        <el-form-item label="设置为环形">
          <el-switch v-model="main.activeOption.radius" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="南丁格尔玫瑰">
          <el-switch v-model="main.activeOption.roseType" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="自动排序">
          <el-switch v-model="main.activeOption.sort" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="不展示零">
          <el-switch v-model="main.activeOption.notCount" size="small"></el-switch>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: 'pie',
  inject: ["main"]
}
</script>

<style></style>